import { IconLoginLogo } from "@/assets/icons/IconLoginLogo";
import { RegisterSuccessForm } from "@/features/auth/components/RegisterSuccessForm";
import { AppRoutes } from "@/routes/config";
import { black } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";

type TRegisterSuccessState = {
  email: string;
};

export const RegisterSuccessPage: FC = () => {
  const location = useLocation();
  const state = location?.state as TRegisterSuccessState | null;

  if (!state?.email) {
    return <Navigate to={AppRoutes.pageNotFound} replace />;
  }

  return (
    <Stack gap="80px" alignItems="center" width="100%">
      <Stack gap={1}>
        <IconLoginLogo />
        <Stack alignItems="center" width={240} paddingY={1} bgcolor={black[30]}>
          <Typography variant="sub16Bold" color="white">
            center│システム管理
          </Typography>
        </Stack>
      </Stack>
      <RegisterSuccessForm />
    </Stack>
  );
};
